export const defaultDarkColor = {
  grey: {
    '900': '#fff',
    '800': '#F6F6F6',
    '700': '#E2E2E2',
    '600': '#B9B9B9',
    '500': '#909090',
    '400': '#676767',
    '300': '#535353',
    '200': '#3F3E3E',
    '100': '#232424',
    '50': '#363636',
  },
  secondary: {
    main: '#B9B9B9',
    '900': '#fff',
    '800': '#F6F6F6',
    '700': '#E2E2E2',
    '600': '#B9B9B9',
    '500': '#909090',
    '400': '#676767',
    '300': '#535353',
    '200': '#3F3E3E',
    '100': '#232424',
    '50': '#363636',
  },
  error: {
    main: '#FF3E52',
    '900': '#72000C',
    '800': '#A50011',
    '700': '#D81A2E',
    '600': '#FF3E52',
    '500': '#FF6979',
    '400': '#FF95A0',
    '300': '#FFC0C7',
    '200': '#FFEBED',
    '100': '#FFEBED',
  },
  warning: {
    main: '#FFB639',
    '900': '#996100',
    '800': '#664000',
    '700': '#996100',
    '600': '#CC8100',
    '500': '#FFA100',
    '400': '#FFB639',
    '300': '#FFCB73',
    '200': '#FFE0AC',
    '100': '#FFF5E5',
  },
  info: {
    main: '#1A8DD8',
    '900': '#003c63',
    '800': '#005084',
    '700': '#0064a5',
    '600': '#1A8DD8',
    '500': '#3EB3FF',
    '400': '#69C4FF',
    '300': '#95D5FF',
    '200': '#EBF7FF',
    '100': '#EBF7FF',
  },
  success: {
    main: '#1AD866',
    '900': '#00491D',
    '800': '#00722E',
    '700': '#00A542',
    '600': '#1AD866',
    '500': '#3EFF8B',
    '400': '#69FFA5',
    '300': '#95FFBF',
    '200': '#C0FFD9',
    '100': '#EBFFF3',
  },
  common: {
    white: '#000',
    black: '#ffffff',
  },
};
export const defaultLightColor = {
  grey: {
    '900': '#000',
    '800': '#232424',
    '700': '#3F3E3E',
    '600': '#535353',
    '500': '#676767',
    '400': '#909090',
    '300': '#B9B9B9',
    '200': '#E2E2E2',
    '100': '#F6F6F6',
    '50': '#FFFFFF',
  },
  secondary: {
    main: '#535353',
    '900': '#000',
    '800': '#232424',
    '700': '#3F3E3E',
    '600': '#535353',
    '500': '#676767',
    '400': '#909090',
    '300': '#B9B9B9',
    '200': '#E2E2E2',
    '100': '#F6F6F6',
    '50': '#FFFFFF',
  },
  error: {
    main: '#D81A2E',
    '900': '#A50011',
    '800': '#72000C',
    '700': '#A50011',
    '600': '#D81A2E',
    '500': '#FF3E52',
    '400': '#FF6979',
    '300': '#FF95A0',
    '200': '#FFC0C7',
    '100': '#FFEBED',
  },
  warning: {
    main: '#FFA100',
    '900': '#FFA100',
    '800': '#664000',
    '700': '#996100',
    '600': '#CC8100',
    '500': '#FFA100',
    '400': '#FFB639',
    '300': '#FFCB73',
    '200': '#FFE0AC',
    '100': '#FFF5E5',
  },
  info: {
    main: '#1A8DD8',
    '900': '#EBF7FF',
    '800': '#003c63',
    '700': '#005084',
    '600': '#0064a5',
    '500': '#1A8DD8',
    '400': '#3EB3FF',
    '300': '#69C4FF',
    '200': '#95D5FF',
    '100': '#EBF7FF',
    '50': '#FFFFFF',
  },
  success: {
    main: '#00A542',
    '900': '#00491D',
    '800': '#00722E',
    '700': '#00A542',
    '600': '#1AD866',
    '500': '#3EFF8B',
    '400': '#69FFA5',
    '300': '#95FFBF',
    '200': '#C0FFD9',
    '100': '#EBFFF3',
  },
  common: {
    white: '#ffffff',
    black: '#000',
  },
};
